import React from 'react';

const serviceRegisterFormModal = React.lazy(() => import('../components/FormModal'));
const serviceRegisterModalRegistry = {
    console_serviceRegisterId: serviceRegisterFormModal
};
export default serviceRegisterModalRegistry;
